<h2 mat-dialog-title>
  {{ translatedData.pageTitle }}
</h2>
<mat-dialog-content>
  <form [formGroup]="formGroup">
    <p class="info-text" [innerHTML]="translatedData.info"></p>
    <glxy-form-field *ngIf="displayInput()" size="large">
      <input
        matInput
        type="text"
        formControlName="reason"
        placeholder="{{ translatedData.inputLabel }}"
        matInput
      />
    </glxy-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close [disabled]="saving$$ | async">
    {{
      'CUSTOMIZE_SALES_ORDERS_DECLINE_REASONS.DIALOG.CANCEL_BUTTON' | translate
    }}
  </button>
  <button
    mat-flat-button
    [color]="data.action === action.ARCHIVE ? 'warn' : 'primary'"
    (click)="save()"
    [disabled]="(saving$$ | async) || !formGroup.valid"
  >
    {{ translatedData.saveButton }}
  </button>
</mat-dialog-actions>
